import React from 'react';
import { useForm } from 'react-hook-form';
import { Book } from './types';
import { db } from '../firebase';

interface EditBookFormProps {
  book: Book;
  onSubmitForm: (book: Book) => void;
  onCancel: () => void;
}

export const EditBookForm = ({
  book,
  onSubmitForm,
  onCancel,
}: EditBookFormProps) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = ({ name, picture, author, genre }: any) => {
    var bookRef = db.collection('books').doc(book.id);
    const newBook: Book = {
      id: book.id,
      name,
      picture,
      author,
      genre,
    };
    bookRef.update(newBook).then(() => onSubmitForm(newBook));
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div>Name:</div>
          <input name="name" ref={register} defaultValue={book.name} />
        </div>
        <div>
          <div>Picture:</div>
          <input name="picture" ref={register} defaultValue={book.picture} />
        </div>
        <div>
          <div>Autor:</div>
          <input name="author" ref={register} defaultValue={book.author} />
        </div>
        <div>
          <div>Género:</div>
          <input name="genre" ref={register} defaultValue={book.genre} />
        </div>
        <input type="submit" />
        <button onClick={onCancel}>cancel</button>
      </form>
    </div>
  );
};
